import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    minHeight: 120,
    padding: 0,
  },
  mainCard: {
    padding: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  cardHeader: {
    paddingLeft: theme.spacing(2.125),
    paddingRight: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  cardTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  boxContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },
}));

export const CardLayout = ({ title, children, onClickMenu }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        action={
          <IconButton onClick={onClickMenu} aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={title}
        className={classes.cardHeader}
        titleTypographyProps={{
          component: "h2",
          variant: "subtitle1",
          noWrap: true,
          className: classes.cardTitle,
        }}
      />
      <CardContent className={classes.mainCard}>
        <Box className={classes.boxContent}>{children}</Box>
      </CardContent>
    </Card>
  );
};

export default CardLayout;
